import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'analytics'),
  uk: createLocale(uk, 'analytics'),
  pl: createLocale(pl, 'analytics'),
  ru: createLocale(ru, 'analytics'),
  es: createLocale(es, 'analytics'),
  uz: createLocale(uz, 'analytics'),
  hi: createLocale(hi, 'analytics'),
};

export default locales;
